export default "__VITE_ASSET__r8VfK7AN__"